import { z } from 'zod';
import { TenantIdSchema } from '../types/common.types';

/**
 * "Utolsó bérlés kosár" szerződés (E-105 Phase 3, Wave-2 BE-3 — klón-CTA).
 *
 * A `GET /rentals/last?partnerId` a partner legutóbbi bérlésének line-item
 * kosarát adja vissza, hogy az FE-A4 „Ugyanaz mint múltkor" CTA hydrate-elje a
 * wizard-store-t. Forrás: `Rental.rentalItems` (gép+mennyiség) +
 * `Rental.packageSelections` (ACTIVE, equipment-scoped csomag + qtyOverrides).
 * A tartozékok a PackageSelection `packageSnapshot`-jában élnek (a csomag tételei).
 */

// Egy bérelt gép-tétel.
export const LastRentalItemSchema = z.object({
  equipmentId: z.string().uuid(),
  quantity: z.number().int().positive(),
});
export type LastRentalItem = z.infer<typeof LastRentalItemSchema>;

// Egy equipment-scoped csomag-választás (ACTIVE) — a hydrate a packageId-t
// re-szelektálja az adott géphez, a qtyOverrides a per-tétel mennyiségek.
export const LastRentalPackageSchema = z.object({
  equipmentId: z.string().uuid(),
  packageId: z.string().uuid(),
  qtyOverrides: z.record(z.number().int().nonnegative()).default({}), // { [itemId]: qty }
});
export type LastRentalPackage = z.infer<typeof LastRentalPackageSchema>;

// Bérlési időszak (a wizard duration-előtöltéshez).
export const LastRentalPeriodSchema = z.object({
  startDate: z.string().datetime(),
  expectedEnd: z.string().datetime(),
  totalDays: z.number().int().positive(),
});
export type LastRentalPeriod = z.infer<typeof LastRentalPeriodSchema>;

// A teljes utolsó-bérlés kosár (klón-hydrate forrás).
export const LastRentalCartSchema = z.object({
  rentalId: z.string().uuid(),
  tenantId: TenantIdSchema,
  partnerId: z.string().uuid(),
  rentalCode: z.string().min(1),
  period: LastRentalPeriodSchema,
  items: z.array(LastRentalItemSchema),
  packages: z.array(LastRentalPackageSchema),
});
export type LastRentalCart = z.infer<typeof LastRentalCartSchema>;

// Válasz: { data } — `null` ha a partnernek nincs korábbi bérlése (CTA rejtve).
export const LastRentalCartResponseSchema = z.object({
  data: LastRentalCartSchema.nullable(),
});
export type LastRentalCartResponse = z.infer<typeof LastRentalCartResponseSchema>;
